/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Statusgroupother2Inputs */

const en__field_statusgroupother2 = /** @type {(inputs: _Field_Statusgroupother2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other group`)
};

const de__field_statusgroupother2 = /** @type {(inputs: _Field_Statusgroupother2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstige Gruppe`)
};

/**
* | output |
* | --- |
* | "other group" |
*
* @param {_Field_Statusgroupother2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_statusgroupother2 = /** @type {((inputs?: _Field_Statusgroupother2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Statusgroupother2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_statusgroupother2(inputs)
	return de__field_statusgroupother2(inputs)
});
export { _field_statusgroupother2 as "_field_statusGroupOther" }